module.exports = __webpack_public_path__ + "static/media/60.3fa66367.webp";